module.exports = __webpack_public_path__ + "img/appointment_btn2.bfa8ba43.png";